module.exports = __webpack_public_path__ + "img/qanda03.89e9060.jpg";